import QsubHomeBanner, { QsubHomeBannerTile } from "../../components/QsubComponents/QsubHomeBanner";
import QsubLayout from "../../layouts/QsubLayout"
import { jobCodes } from "../../util/data/jobCodes";
import React, {useEffect} from "react";
import QsubHomeBannerImg from "../../assets/qsub-home-banner.png";
import QsubHomeBannerImgMob from "../../assets/qsub-home-banner-mob.png";
// import QsubLogo from "../../assets/keytruda-subq-logo-trimmed.png";
import QsubLogo from "../../assets/keytruda-qlex-logo.svg";
import { BreakoutContentCard, BreakoutContentRow, EndpointDisplay, PageSection, PageSubSection, PrimaryCallOut, SecondaryCallout, RelatedContent, CrossLink, PSAImageStepsList, TriageList, FilterProvider, FeaturedCTA } from "../../components";
import styled from "styled-components";
import { DefinitionBlock, Footnote, Heading, Text, WYSIWYG } from "../../util/typography";
import TemplateColumn, { TemplateColumnWithSidebarContainer } from '../../layouts/TemplateColumn';
import { NAVIGATION_BREAKPOINT, NAVIGATION_BREAKPOINT_UNITLESS } from "../../constants/layout";
import * as colors from "../../util/colors"
import QsubStudyDesign from "../../components/StudyDesign/__study-design/subq";
import { QsubWYSIWYG } from "../../util/typography/WYSIWYG";
import { createMarkup } from "../../util/functions";
import { ResponsiveHeadData, ResponsiveRowData, ResponsiveTable } from "../../components/QsubComponents/ResponsiveTable";
import FadeAnimation from "../../components/Animations/FadeAnimation";
import icon from '../../assets/icon-zoom-purple.svg';
import QLexTorso from '../../assets/qlex-torso.svg'
import { between } from "polished";
import qsubSafetyList from "../../components/IndicationAndSafety/data/qsubSafety";
import psaCheckIcon from '../../assets/psa-check-icon.svg';
import injectionIcon from '../../assets/injection-icon.svg';
import DoseQ3W from '../../assets/doseQ3W.png';
import DoseQ6W from '../../assets/doseQ6W.png';
import dualArrow from '../../assets/qlex-dual-arrow.svg'
import IconCount1 from '../../assets/IconCount1.svg';
import IconCount2 from '../../assets/IconCount2.svg';
import IconCount3 from '../../assets/IconCount3.svg';
import IconCount4 from '../../assets/IconCount4.svg';
import IconCount5 from '../../assets/IconCount5.svg';
import AddedConvenienceIcon from '../../assets/added-convenience-icon.svg';
import SimplifiedAdministrationIcon from '../../assets/simplified-administration-icon.svg';
import FasterIcon from '../../assets/faster-icon.svg';
import Exclamation_icon_qsub from '../../assets/icons/exclamation-icon-qsub.svg';


// SEO INFORMATION
const pageMeta = {
    title: `KEYTRUDA QLEX™ (pembrolizumab and berahyaluronidase alfa-pmph)`,
    keywords: `qlex, subcutaneous`,
    description: `Learn more about KEYTRUDA QLEX™ (pembrolizumab and berahyaluronidase alfa-pmph). See study results (MK-3475A-D77), dosing and administration information, and more here.`,
    schemaJsonLD: [
        `{"@context":"https://schema.org/","url":"https://www.keytrudahcp.com/qlex/","@type":"ApprovedIndication","name":"KEYTRUDA QLEX™","alternateName":"KEYTRUDA QLEX Is Approved for Use in Adult Patients Across Solid Tumor Indications for KEYTRUDA—Whether Alone or in Combination With Other Therapies"}`,
        `{"@context":"https://schema.org/","url":"https://www.keytrudahcp.com/qlex/","@type":"MedicalAudience","audienceType":"Health Care Professionals","geographicArea":"This site is intended for health care professionals of the United States, its territories, and Puerto Rico."}`,
        `{"@context":"https://schema.org/","url":"https://www.keytrudahcp.com/qlex/","@type":"MedicalWebPage","name":"KEYTRUDA QLEX","description":"Patients have the option to switch from KEYTRUDA to KEYTRUDA QLEX—or KEYTRUDA QLEX to KEYTRUDA—at their next scheduled dose"}`,
        `{"@context":"https://schema.org/","url":"https://www.keytrudahcp.com/qlex/","@type":"MedicalWebPage","name":"Administration Information","description":"Administer KEYTRUDA QLEX as a subcutaneous injection into the thigh or abdomen, avoiding the 5-cm area around the navel"}`,
        `{"@context":"https://schema.org/","url":"https://www.keytrudahcp.com/qlex/","@type":"MedicalWebPage","name":"Storing the Prepared Syringe","description":"KEYTRUDA QLEX does not contain a preservative and should be used immediately after withdrawing from the vial."}`,
        `{"@context":"https://schema.org/","url":"https://www.keytrudahcp.com/qlex/","@type":"MedicalTrial","name":"MK-3475A-D77 Study Design","description":"KEYTRUDA QLEX Was Studied to Evaluate Its Comparability to KEYTRUDA","trialDesign":"RandomizedTrial"}`,
        `{"@context":"https://schema.org/","url":"https://www.keytrudahcp.com/qlex/","@type":"RecommendedDoseSchedule","doseUnit":"mL","doseValue":"2.4","frequency":"For every-3-week dosing (395 mg/4,800 units): inject 2.4 mL subcutaneously in 1 minute"}`,
        `{"@context":"https://schema.org/","url":"https://www.keytrudahcp.com/qlex/","@type":"RecommendedDoseSchedule","doseUnit":"mL","doseValue":"4.8","frequency":"For every-6-week dosing (790 mg/9,600 units): inject 4.8 mL subcutaneously in 2 minutes"}`
    ]
}

const jobCode = jobCodes[38].jobCode;

const crossLinkContent = {
    sections: [
        {
            heading: 'Related Information',
            items: [
                { text: 'Patient Site', url: 'https://www.keytruda.com/qlex/', target: "_blank" },
            ]
        },
    ],
    interestLinks: {
        heading: 'You Might Be Interested In',
        items: [
            {
                eyebrow: 'Resources',
                text: 'The Merck Access Program',
                url: 'https://www.merckaccessprogram-keytruda.com/keytrudaqlex/hcp/',
                target: "_blank"
            },
        ],
    },
};
const relatedContent = [
    {
        section: 'Resources',
        link: {
            url: 'https://www.merckaccessprogram-keytruda.com/keytrudaqlex/hcp/',
            label: 'Merck Access Program',
        },
    },
    {
        section: 'Resources',
        link: {
            url: 'https://www.keytruda.com/qlex/',
            label: 'Patient Site',
            target: '_blank'
        },
    },
];

const PrepStepsList = [
    {
        count: IconCount1,
        alt: '',
        stepNumAlt: '',
        instruction: 'Equilibrate the Vial',
        details: <><QsubWYSIWYG>Remove KEYTRUDA QLEX vial from refrigerated storage (2°C to 8°C [36°F to 46°F]) and allow it to equilibrate to room temperature (20°C to 25°C [68°F to 77°F]) for at least 30 minutes.
            <ul>
                <li>Prior to preparation for administration, if needed, the unpunctured vial may be stored at room temperature for up to 24 hours</li>
            </ul>
        </QsubWYSIWYG>
        </>
    },
    {
        count: IconCount2,
        alt: '',
        stepNumAlt: '',
        instruction: 'Inspect the Vial',
        details: <><QsubWYSIWYG><p>Parenteral drug products should be inspected visually for particulate matter and discoloration prior to administration, whenever solution and container permit. The solution is clear to slightly opalescent, colorless to slightly yellow. <strong>Discard the vial if visible particles are observed.</strong></p></QsubWYSIWYG></>
    },
    {
        count: IconCount3,
        alt: '',
        stepNumAlt: '',
        instruction: 'Withdraw With a Transfer Needle',
        details: <>Use a sterile, polypropylene or polycarbonate syringe and a stainless steel <strong>transfer needle (18 to 21 gauge)</strong> to withdraw KEYTRUDA QLEX from the vial.
            <QsubWYSIWYG>
                <ul>
                    <li>Every-3-week dosing (395 mg pembrolizumab and 4,800 units berahyaluronidase alfa): withdraw 2.4 mL into the syringe</li>
                    <li>Every-6-week dosing (790 mg pembrolizumab and 9,600 units berahyaluronidase alfa): withdraw 4.8 mL into the syringe</li>
                </ul>
            </QsubWYSIWYG></>,
    },
    {
        count: IconCount4,
        alt: '',
        stepNumAlt: '',
        instruction: 'Change to an Injection Needle',
        details: 'To avoid needle clogging, <strong>change the needle to a 25 to 30 gauge, ½-inch, stainless steel hypodermic injection needle</strong> immediately prior to subcutaneous injection.',
    },
    {
        count: IconCount5,
        alt: '',
        stepNumAlt: '',
        instruction: 'Discard Any Unused Portion Left in the Vial',
        end: 'true'
    }
];
const PrepStepsList2 = [
    {
        count: AddedConvenienceIcon,
        alt: '',
        stepNumAlt: '',
        instruction: 'Added Convenience',
        details: <><QsubWYSIWYG><p>KEYTRUDA QLEX may provide added convenience compared to KEYTRUDA because it can be administered by a healthcare provider in multiple settings from an infusion center to a doctor’s office or a local community-based clinic, providing more options where patients can receive their treatment.</p></QsubWYSIWYG>
        </>
    },
    {
        count: SimplifiedAdministrationIcon,
        alt: '',
        stepNumAlt: '',
        instruction: 'Simplified Administration',
        details: <><QsubWYSIWYG><p>For patients who do not require a port or whose veins are difficult to access, subcutaneous administration may simplify treatment administration.</p></QsubWYSIWYG></>
    },
    {
        count: FasterIcon,
        alt: '',
        stepNumAlt: '',
        instruction: 'Faster',
        details: <><QsubWYSIWYG>
            <p>
                KEYTRUDA QLEX provides faster administration than KEYTRUDA<sup>d</sup> and offers 2 dosing options.
            </p>
        </QsubWYSIWYG></>,
        end: 'true'
    }
];

const StoreList = [
    {
        image: DoseQ3W,
        alt: 'A Single Dose Vial of KEYTRUDA QLEX™ (pembrolizumab and berahyaluronidase alfa-pmph) With a Yellow Cap',
        instruction: 'Q3W Dose',
        capText: <strong>Yellow Cap</strong>,
        footnote: 'NDC 0006-3083-01',
        disclaimer: 'Vial and carton shown to scale, not actual size.',
        details: '395 mg pembrolizumab and 4,800 units berahyaluronidase alfa per 2.4 mL (165&nbsp;mg/2,000 units per mL)'
    },

    {
        image: DoseQ6W,
        alt: 'A Single Dose Vial of KEYTRUDA QLEX™ (pembrolizumab and berahyaluronidase alfa-pmph) With a Light Green Cap',
        instruction: 'Q6W Dose',
        capText: <strong>Light Green Cap</strong>,
        footnote: 'NDC 0006-5083-01',
        disclaimer: 'Vial and carton shown to scale, not actual size.',
        details: '790 mg pembrolizumab and 9,600 units berahyaluronidase alfa per 4.8 mL (165&nbsp;mg/2,000 units per mL)',
        end: true
    }
]

const SectionOneContent = styled(WYSIWYG)`
margin-top:20px;
margin-bottom:40px;
`;

const QSUBLocationCard = styled.div`
>div{
    h3{
    text-align: center;
} 
    div:nth-of-type(2) {
    text-align: center;
    p{
    margin-bottom: 0px;
    }
    }
}
`;

const QsubStudyDesignWrapper = styled.div`
table{
strong{
font-weight: 600;
}
}
.box-white {
  text-align: left !important;
}
  .box-white dt {
  text-align: center;
}
`;

const SpacerWrapper = styled.div`
  margin-top: ${({ mobSpace, deskSpace }) =>
        (mobSpace !== undefined ? mobSpace : deskSpace) * 2}px !important;

  @media (min-width: 769px) {
    margin-top: ${({ deskSpace }) => deskSpace * 2}px !important;
  }
`;

const CharcoalColor = styled.div`
 * {
color: ${colors.charcoal} !important;
}
ul{
    li{
        strong{
            font-weight: 500;
        }
    }
}
`

const CustomRemoveSpacer = styled.div`
> [class^="ComponentWrapper-"]{
        margin-bottom:0px;
        b{
        color:${colors.charcoal};
        }
    }
    margin-bottom: -20px;
    @media(max-width: ${NAVIGATION_BREAKPOINT}){
    margin-bottom: 0px;
    } 
    
`;

const QsubWYSIWYGWrapper = styled(QsubWYSIWYG)`
p, ul {
strong {
        font-weight: 600;
    }
}
`;


const PinchContainer = styled.div`
    display: flex;
    align-items: center;
    margin-top: 16px;
    margin-bottom: 20px;
    @media (hover:hover) {
        display: none;
    }
`;

const PinchIcon = styled.span`
    height: 40px;
    width: 40px;
    display: block;
    background-size: 35px 35px;
    background-repeat: no-repeat;
    background-image: url(${icon});
    margin-right: 6px;
`;

const PinchLabel = styled(Text.Eyebrow)`
    text-transform: uppercase;
    color: ${colors.slate};
`;
const PageSectionTitle = styled(Heading.H2)`
    text-align: ${({ $centerTitle }) => ($centerTitle ? 'center' : 'left')};
    &.marginBottom{
        margin-bottom: 40px;
        @media (max-width: ${NAVIGATION_BREAKPOINT}){
            margin-bottom: 30px;
        }
    }
/* 
    @media (min-width: 321px) and (max-width: 1032px) {
        margin-bottom: ${between('20px', '30px', '320px', '1032px')};
    }

    @media (min-width: 1033px) {
        margin-bottom: 30px;
    } */
`;

const ResultSectionWrapper = styled.div`
#results {
 display: block;
    height: 0;
    overflow: hidden;
    line-height:none;
    transform: translateY(-110px);
//   scroll-margin-top: 95px;
}
`

const ContentCardWrapper = styled.div`
// margin: 30px auto;
max-width: 824px;
box-sizing: border-box;
background: ${colors.white};
margin: 20px 20px 40px;
@media (min-width: ${NAVIGATION_BREAKPOINT}) {
        margin: 20px auto 60px;        
    }        
    >div{
        >div{
        @media (max-width: ${NAVIGATION_BREAKPOINT}) {
            gap: 30px;
        }
        
        div{
        margin-top: 0px;
        margin-bottom: 0px;
        p{
        margin-top:0px;
        }
        }
        }
        // @media (max-width: ${NAVIGATION_BREAKPOINT}) {
        //     margin-bottom: 46px;
        // }
    } 


`;

const StyledCaption = styled(Text.Caption)`
font-weight: 400;
`;

const AbdomenHeading = styled(Heading.H4)`
strong {
font-weight: 600;
}`;

const ImageWrapper = styled.div`
display: flex;
border: 1px solid ${colors.pebble};
border-radius: 8px;
width: 100%;
height: 362px;
background-image: url(${QLexTorso});
background-position: center;
background-repeat: no-repeat;
background-size: contain;

@media (max-width: ${NAVIGATION_BREAKPOINT}){
    height: 243px;  
    background-size: cover;  
}
`;

const PSAfootnote = styled(Text.Footnote)`
color: ${colors.ink};
`;

const QsubWYSIWYGTextWrapper = styled(QsubWYSIWYG)`
    p {
    color: ${colors.ink}
    }`
    ;

const PSAImageStepsListWrapper = styled.div`
  > div > div > div > div:nth-child(2) > div {
    max-width: unset;
  }
    > div > div > div > div:nth-child(1){
    margin-bottom: 20px !important;
    }
   [class^="WYSIWYG"],
[class^="PSAimageStepsList__PSADetails"] p {
  margin-bottom: 20px !important;
  @media (max-width: ${NAVIGATION_BREAKPOINT}) {
    margin-bottom: 20px !important;
  }
}

[class^="PSAimageStepsList__Container"]:last-of-type 
[class^="PSAimageStepsList__StepNumContainer"]  {
margin-bottom: 0px !important;
@media (max-width: ${NAVIGATION_BREAKPOINT}) {
margin-bottom: 20px !important;
}
}

[class^="PSAimageStepsList__Container"]:last-of-type 
  [class^="WYSIWYG"],[class^="PSAimageStepsList__PSADetails"] p {
  margin-bottom: 0 !important;
}

[class^="Footnote__FootnoteWrapper"]{
    margin-top: 20px;
    }
`;

const TriageListWrapper = styled.div`
[class^="Heading__H7"],
  [class^="BoxedDefinitionList__ItemTitle"] {
    background: ${colors.extraLightPurple};
  }
    [class^="BoxedDefinitionList__ItemText"] ul li::before {
  background-color: ${colors.lightPurple};
}
   [class*="ComponentWrapper"][class*="AccordionGroup__StyledComponentWrapper"] {
  margin-bottom: 0px !important;
}
//    [class^="ComponentWrapper"],[class^="AccordionGroup__StyledComponentWrapper"]{
//   margin-bottom: 0px !important;
//   }
[class*="ExclamationList__ItemTextContainer"] {
  &:before {
  background-image: url(${Exclamation_icon_qsub});
  }
}
`

const ScrollCont = styled.div`
scroll-margin-top: 80px;`

// const AnchorTargetLink = styled.span`
//     display: block;
//     height: 0;
//     overflow: hidden;
//     line-height:none;
//     transform: translateY(-120px); //manage offset for fully-expanded sticky nav
// `;

const Spacer = ({ deskSpace, mobSpace }) => {
    return <SpacerWrapper deskSpace={deskSpace} mobSpace={mobSpace} />;
};

const Page = ({ location }) => {
    const qsub = true;
    const hash  = location.hash;
 
    useEffect(() => {
        if (hash) {
        const el = document.querySelector(hash);
        if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
        else {
        window.scrollTo(0, 0);
            }
        }
    }, [hash]);

    return (
        <FilterProvider>
        <QsubLayout jobCode={jobCode} pageMeta={pageMeta} location={location} qsub={qsub} safetyDataOverride={qsubSafetyList}>
            <div data-template-name="template-e">
                <QsubHomeBanner imgSrc={QsubHomeBannerImg} mobSrc={QsubHomeBannerImgMob} imgMark="Actor Portrayal"
                    footNoteContent={<><sup>a</sup>Does not account for all aspects of treatment. Actual clinic time may vary.</>}
                    logo={QsubLogo} logoAlt="KEYTRUDA QLEX™ (pembrolizumab and berahyaluronidase alfa-pmph) Logo"
                >
                    <QsubHomeBannerTile hasEdge={false} content="Proven Consistent With KEYTRUDA" backColor="linear-gradient(106deg, var(--color-keytruda-green-web-acc, #2C6D3C) 12.85%, var(--color-keytruda-green-web-acc, #2C6D3C) 45.72%, var(--color-keytruda-green-for-banner, #36864A) 96.23%);" />
                    <QsubHomeBannerTile content={<>Administered in 1 or 2 Minutes<sup>a</sup></>} backColor="linear-gradient(106deg, #4A0075 0%, #5A008F 28.26%, #6A00A8 55.05%, #7C02BB 78.93%, #8215BA 101.34%);" />
                </QsubHomeBanner>

                {/* Begin Intro Column */}
                <TemplateColumn id="template-e-intro" maxWidth={824}>
                    <ContentCardWrapper>
                        <QsubWYSIWYGWrapper>
                            <QsubWYSIWYG>
                                <p><strong>KEYTRUDA QLEX Is Approved for Use in Adult Patients Across Solid Tumor Indications for KEYTRUDA—Whether Alone or in Combination With Other Therapies Depending on the Type of Cancer</strong></p>
                                <StyledCaption>One such indication is for the adjuvant treatment of adult patients with renal cell carcinoma (RCC) at intermediate-high or high risk of recurrence following nephrectomy, or following nephrectomy and resection of metastatic lesions.</StyledCaption>
                            </QsubWYSIWYG>
                        </QsubWYSIWYGWrapper>
                        <Spacer deskSpace={-10} mobSpace={-5} />
                        <BreakoutContentRow>
                            <BreakoutContentCard url="#mk-3475a-d77-study-design" isClickable={true} qsubTitle="Consistent Pharmacokinetics With KEYTRUDA" isQsub={true} buttonLabel="View Study Design" cardType="green">
                                <WYSIWYG>
                                    <ul>
                                        <li>Cycle 1 AUC<sup>b</sup><sub>0-6wks</sub> showed comparable pembrolizumab exposure of KEYTRUDA QLEX as compared to KEYTRUDA, with a geometric mean ratio of 1.14 (96% CI: 1.06, 1.22)</li>
                                        <li>Cycle 3 C<sub>trough</sub><sup>c</sup> (ie, steady state) showed comparable pembrolizumab exposure of KEYTRUDA QLEX as compared to KEYTRUDA, with a geometric mean ratio of 1.67 (94% CI: 1.52, 1.84)</li>
                                    </ul>
                                </WYSIWYG>
                            </BreakoutContentCard>
                            <BreakoutContentCard qsubTitle="Q3W and Q6W Dosing Options" isQsub={true} cardType="purple">
                                <QsubWYSIWYG>
                                    <ul>
                                        <li>KEYTRUDA QLEX must be administered by a healthcare provider</li>
                                        <li>KEYTRUDA QLEX is administered as a subcutaneous injection into the thigh or abdomen, avoiding the 5-cm area around the navel</li>
                                        <li>Q3W: 2.4 mL administered in 1 minute (395 mg pembrolizumab/4,800 units berahyaluronidase alfa)</li>
                                        <li>Q6W: 4.8 mL administered in 2 minutes (790 mg pembrolizumab/9,600 units berahyaluronidase alfa)</li>
                                    </ul>
                                </QsubWYSIWYG>
                            </BreakoutContentCard>
                        </BreakoutContentRow>
                        <Spacer deskSpace={30} mobSpace={25} />
                        <Footnote label="b." text="AUC was used to measure how much pembrolizumab was present in the bloodstream from 0 to 6 weeks." />
                        <Footnote label="c." text="Steady state C<sub>trough</sub> was used to measure the lowest concentration of pembrolizumab at steady state during cycle 3." />
                        <DefinitionBlock
                            text={`AUC = area under the curve; Cl = confidence interval; C<sub>trough</sub> = trough concentration; Q3W = every 3 weeks; Q6W = every 6 weeks; wks = weeks.`}
                        />
                        {/* </PageSection> */}
                        <Spacer deskSpace={50} mobSpace={45} />
                        <PageSubSection title="KEYTRUDA QLEX offers additional considerations for you and your patients to discuss" isQsub={true}>
                            <PSAImageStepsListWrapper>
                                <PSAImageStepsList data={PrepStepsList2} stepCount={PrepStepsList2.length} theme='cloud' brandType="qsub"></PSAImageStepsList>
                                <Footnote label="d." text="Does not account for all aspects of treatment. Actual clinic time may vary." />
                            </PSAImageStepsListWrapper>
                        </PageSubSection>
                    </ContentCardWrapper>
                    {/* <PageSection bgColor="qsubgradient" centerTitle={true} title="Study Design" /> */}


                </TemplateColumn>
                <TemplateColumnWithSidebarContainer>
                    <TemplateColumn id="template-e-main">
                        <PageSection bgColor="cloud" title="MK-3475A-D77 Study Design">
                            {/* <Spacer deskSpace={20} mobSpace={15} /> */}
                            <PageSubSection isQsub={true} title="KEYTRUDA QLEX Was Studied to Evaluate Its Comparability to KEYTRUDA">
                                <Spacer deskSpace={-5} />
                                <QsubWYSIWYG>
                                    <p>In MK-3475A-D77, KEYTRUDA QLEX was evaluated in a randomized, multicenter, active-controlled <span style={{ whiteSpace: 'nowrap' }}>open-label</span> study of the pharmacokinetics, efficacy, and safety of KEYTRUDA QLEX in combination with chemotherapy vs KEYTRUDA in combination with chemotherapy for the first-line treatment of patients with metastatic non–small cell lung cancer (mNSCLC).</p>
                                </QsubWYSIWYG>
                                <QsubStudyDesignWrapper>
                                    <QsubStudyDesign isQsub={true} />
                                </QsubStudyDesignWrapper>
                                <Footnote label="e." text="Randomization was stratified by ECOG PS (0 vs 1), histology (squamous vs nonsquamous), PD-L1 TPS (<50% vs ≥50%), and geographic region (East Asia vs North America/Western Europe/Australia/New Zealand vs Rest of the World)." />
                                <Footnote label="f." text="Pemetrexed 500 mg/m<sup>2</sup> IV + cisplatin 75 mg/m<sup>2</sup> IV or carboplatin AUC 5 mg/mL/min IV Q3W for 4 cycles, followed by pemetrexed 500 mg/m<sup>2</sup> IV Q3W." />
                                <Footnote label="g." text="Carboplatin AUC 6 mg/mL/min IV + paclitaxel 200 mg/m<sup>2</sup> IV on day 1 of each 21-day cycle or paclitaxel protein-bound 100 mg/m<sup>2</sup> IV on days 1, 8, and 15 of each 21-day cycle IV Q3W for 4 cycles." />
                                <Footnote label="h." text="Administration of KEYTRUDA QLEX or KEYTRUDA was permitted beyond RECIST v1.1-defined disease progression by BICR or beyond discontinuation of pemetrexed if the patient was clinically stable and deriving clinical benefit as determined by the investigator." />
                                <DefinitionBlock text="<i>ALK</i> = anaplastic lymphoma kinase; ECOG PS = Eastern Cooperative Oncology Group performance status; <i>EGFR</i> = epidermal growth factor receptor; Gy = gray unit; IV = intravenous; PD-L1 = programmed death ligand 1; RECIST v1.1 = Response Evaluation Criteria In Solid Tumors v1.1; <i>ROS1</i> = ROS proto-oncogene 1, receptor tyrosine kinase; SC = subcutaneous; TPS = tumor progression score." />
                            </PageSubSection>
                            {/* <Spacer deskSpace={20} /> */}
                            <PageSubSection title="Clinical Trial Patient Demographics" isQsub={true}>
                                <Heading.H4 dangerouslySetInnerHTML={createMarkup("MK-3475A-D77: Patient Baseline Demographics and Characteristics")} />
                                {/* Table No.1 */}

                                <Spacer deskSpace={10} mobSpace={5} />
                                <PinchContainer>
                                    <PinchIcon />
                                    <PinchLabel>Pinch to zoom & enlarge</PinchLabel>
                                </PinchContainer>
                                <ResponsiveTable
                                    cssData={`
                                        border-radius: 8px 8px 0 0;
                                        border-bottom:1px solid ${colors.darkPurple};
                                        box-shadow: -4px 0 6px -2px rgba(0,0,0,0.1), 4px 0 6px -2px rgba(0,0,0,0.1);
                                        `}
                                >
                                    <ResponsiveHeadData headerType="purple-fill" headerData={[
                                        {
                                            width: 10,
                                            ThData: "Patient Characteristics"
                                        },
                                        {
                                            width: 2,
                                            ThData: <p className="text-center">All Patients (N=377)</p>
                                        },

                                    ]} />
                                    <ResponsiveRowData rowData={[
                                        {
                                            rowType: "grey-bg-purple-border",
                                            rowTdData: [{ colSpan: 2, content: "Median Age, years (range)" }]
                                        },
                                        {
                                            rowType: "",
                                            rowTdData: [{ content: "Median age (range)" }, { content: <p className="text-center fw-400 text-charcoal">65 (37-87)</p> }]
                                        },
                                        {
                                            rowType: "grey-bg-purple-border",
                                            rowTdData: [{ colSpan: 2, content: "Sex (%)" }],
                                        },
                                        {
                                            rowType: "",
                                            rowTdData: [{ content: "Male" }, { content: <p className="text-center fw-400 text-charcoal">71</p> }]
                                        },
                                        {
                                            rowType: "grey-bg-purple-border",
                                            rowTdData: [{ colSpan: 2, content: "Ethnicity/race (%)" }],
                                        },
                                        {
                                            rowType: "",
                                            rowTdData: [{ content: "White" }, { content: <p className="text-center fw-400 text-charcoal">63</p> }]
                                        },
                                        {
                                            rowType: "bg-cloud",
                                            rowTdData: [{ content: "Asian" }, { content: <p className="text-center fw-400 text-charcoal">29</p> }]

                                        },
                                        {
                                            rowType: "",
                                            rowTdData: [{ content: "Multiracial" }, { content: <p className="text-center fw-400 text-charcoal">4</p> }]
                                        },
                                        {
                                            rowType: "bg-cloud",
                                            rowTdData: [{ content: "Black or African American" }, { content: <p className="text-center fw-400 text-charcoal">3</p> }]
                                        },
                                        {
                                            rowType: "",
                                            rowTdData: [{ content: "American Indian or Alaska Native" }, { content: <p className="text-center fw-400 text-charcoal">2</p> }]

                                        },
                                        {
                                            rowType: "bg-cloud",
                                            rowTdData: [{ content: "Hispanic or Latino" }, { content: <p className="text-center fw-400 text-charcoal">31</p> }]
                                        },
                                        {
                                            rowType: "grey-bg-purple-border",
                                            rowTdData: [{ colSpan: 2, content: "ECOG PS (%)" }],
                                        },
                                        {
                                            rowType: "",
                                            rowTdData: [{ content: "0" }, { content: <p className="text-center fw-400 text-charcoal">35</p> }]
                                        },
                                        {
                                            rowType: "bg-cloud",
                                            rowTdData: [{ content: "1" }, { content: <p className="text-center fw-400 text-charcoal">65</p> }]
                                        },
                                        {
                                            rowType: "grey-bg-purple-border",
                                            rowTdData: [{ colSpan: 2, content: "PD-L1 expression (%)" }],
                                        },
                                        // {
                                        //     rowType: "",
                                        //     rowTdData: [{ content: "TPS <50%" }, { content: <p className="text-center fw-400 text-charcoal">81</p> }]
                                        // },
                                        {
                                            rowType: "bg-cloud",
                                            rowTdData: [{ content: "TPS ≥50%" }, { content: <p className="text-center fw-400 text-charcoal">19</p> }]
                                        },
                                        {
                                            rowType: "grey-bg-purple-border",
                                            rowTdData: [{ colSpan: 2, content: "Histology (%)" }],
                                        },
                                        {
                                            rowType: "",
                                            rowTdData: [{ content: "Nonsquamous" }, { content: <p className="text-center fw-400 text-charcoal">66</p> }]
                                        },
                                        {
                                            rowType: "bg-cloud",
                                            rowTdData: [{ content: "Squamous" }, { content: <p className="text-center fw-400 text-charcoal">34</p> }]
                                        },
                                        {
                                            rowType: "",
                                            rowTdData: [{ content: "Brain metastases at baseline" }, { content: <p className="text-center fw-400 text-charcoal">9</p> }]
                                        },
                                    ]} />
                                </ResponsiveTable>
                                <Spacer deskSpace={10} />
                                <DefinitionBlock text="TPS = tumor proportion score; ECOG PS = Eastern Cooperative Oncology Group performance status; PD-L1 = programmed death ligand 1." />
                            </PageSubSection>
                        </PageSection>
                        <ResultSectionWrapper>
                            <PageSection bgColor="white">
                                <div id="results"></div>
                                <PageSectionTitle
                                    as='H2'
                                    theme='dark'
                                    dangerouslySetInnerHTML={createMarkup("Results")}
                                    className="marginBottom"
                                />
                                <Spacer deskSpace={15} />
                                <PageSubSection title="Primary Outcome Measure" isQsub={true}>
                                    <Heading.H4 dangerouslySetInnerHTML={createMarkup('Pembrolizumab Exposure of KEYTRUDA QLEX as Compared to KEYTRUDA')} />
                                    <Spacer deskSpace={10} />
                                    {/* <AnchorTargetLink id="results" /> */}
                                    <PinchContainer>
                                        <PinchIcon />
                                        <PinchLabel>Pinch to zoom & enlarge</PinchLabel>
                                    </PinchContainer>
                                    <ResponsiveTable
                                        cssData={`
                                        border-radius: 8px 8px 0 0;
                                        border-bottom:1px solid ${colors.darkPurple};
                                        box-shadow: -4px 0 6px -2px rgba(0,0,0,0.1), 4px 0 6px -2px rgba(0,0,0,0.1);
                                        `}
                                    >
                                        <ResponsiveHeadData headerType="purple-fill" headerData={[
                                            {
                                                width: 6,
                                                ThData: "Pharmacokinetic Parameters"
                                            },

                                            {
                                                width: 2,
                                                ThData: <p className="text-center">Geometric Mean Ratio <sup style={{ marginLeft: '-3px' }}>i</sup></p>
                                            },

                                        ]} />
                                        <ResponsiveRowData rowData={[
                                            {
                                                rowType: "bg-cloud",
                                                rowTdData: [
                                                    { content: <p><strong>Cycle 1 <span className="text-nowrap">AUC<sub>0–6wks</sub></span></strong></p> },
                                                    { content: <p className="text-center fw-400 text-charcoal"><strong>1.14</strong><br />(96% CI: 1.06, 1.22)</p> },
                                                ]
                                            },
                                            {
                                                rowType: "bg-mist",
                                                rowTdData: [
                                                    { content: <p><strong>Cycle 3 C<sub>trough</sub> (ie, steady state)</strong></p> },
                                                    { content: <p className="text-center fw-400 text-charcoal"><strong>1.67</strong><br />(94% CI: 1.52, 1.84)</p> },
                                                ]
                                            },

                                        ]} />
                                    </ResponsiveTable>
                                    <Spacer deskSpace={10} />
                                    <QsubWYSIWYG>
                                        <Footnote label="i." text="Geometric mean ratio of KEYTRUDA QLEX to KEYTRUDA." />
                                    </QsubWYSIWYG>
                                    <Spacer deskSpace={15} />
                                    <QsubWYSIWYG>
                                        <p><strong>In MK-3475A-D77, the pembrolizumab exposure for KEYTRUDA QLEX was comparable to that of KEYTRUDA, as measured by cycle 1 AUC<sub>0-6wks</sub> and cycle 3 (ie, steady state) C<sub>trough</sub></strong></p>
                                    </QsubWYSIWYG>
                                    <Spacer deskSpace={20} />
                                </PageSubSection>
                                {/* <Spacer deskSpace={20} /> */}
                                <Heading.H3
                                    as='H2'
                                    dangerouslySetInnerHTML={createMarkup('Additional Descriptive Efficacy Outcome Measures')}
                                />
                                <Spacer deskSpace={9} />
                                <QsubWYSIWYG>
                                    <p><strong>Efficacy was a descriptive analysis and was not powered to demonstrate statistical significance</strong></p>
                                </QsubWYSIWYG>
                               <Spacer deskSpace={-18} mobSpace={-13} />
                                <PageSubSection isQsub={true}>
                                    <QsubWYSIWYG>
                                        <p>In 251 patients with mNSCLC who received KEYTRUDA QLEX + chemotherapy and 126 patients with mNSCLC who received KEYTRUDA + chemotherapy</p>                
                                    </QsubWYSIWYG>
                                    <Spacer deskSpace={15} mobSpace={15} />
                                    <Heading.H4 dangerouslySetInnerHTML={createMarkup("Overall Response Rate")} />
                                    <Spacer deskSpace={10} mobSpace={5} />
                                    <PinchContainer>
                                        <PinchIcon />
                                        <PinchLabel>Pinch to zoom & enlarge</PinchLabel>
                                    </PinchContainer>
                                    <ResponsiveTable
                                        cssData={`
                                        border-radius: 8px 8px 0 0;
                                        border-bottom:1px solid ${colors.darkPurple};
                                        th, tr td {
                                        padding: 10px 20px;
                                        }
                                        th p{
                                        line-height: 22px;}
                                        box-shadow: -4px 0 6px -2px rgba(0,0,0,0.1), 4px 0 6px -2px rgba(0,0,0,0.1);
                                        `}
                                    >
                                        <ResponsiveHeadData headerType="charcoal-fill" headerData={[
                                            {
                                                width: 3,
                                                ThData: ""
                                            },
                                            {
                                                width: 3,
                                                ThData: <p className="text-center">KEYTRUDA QLEX</p>
                                            },
                                            {
                                                width: 3,
                                                ThData: <p className="text-center">KEYTRUDA</p>
                                            },

                                        ]} />
                                        <ResponsiveRowData rowData={[
                                            {
                                                rowType: "bg-cloud",

                                                rowTdData: [
                                                    { content: <p><strong>ORR</strong></p> },
                                                    { content: <p className="text-center fw-400 text-charcoal">45% <br />(95% CI: 39, 52)</p> },
                                                    { content: <p className="text-center fw-400 text-charcoal">42% <br />(95% CI: 33, 51)</p> }
                                                ]
                                            },

                                        ]} />
                                    </ResponsiveTable>
                                    <Spacer deskSpace={20} />
                                    <Heading.H4 dangerouslySetInnerHTML={createMarkup("Progression-Free Survival (PFS) and Overall Survival (OS)")} />
                                    <Spacer deskSpace={10} />
                                    <QsubWYSIWYG>
                                        <p>No notable differences in PFS or OS were observed between KEYTRUDA QLEX and KEYTRUDA</p>
                                    </QsubWYSIWYG>
                                    <Spacer deskSpace={20} />
                                    <SecondaryCallout
                                        title="The effectiveness of KEYTRUDA QLEX for its approved indications has been established based upon the evidence from:"
                                        text={<QsubWYSIWYG>
                                            <ul>
                                                <li>The adequate and well-controlled studies conducted with KEYTRUDA</li>
                                                <li>Additional data that demonstrated comparable pharmacokinetic, efficacy, and safety profiles between KEYTRUDA QLEX and KEYTRUDA in study MK-3475A-D77</li>
                                            </ul>
                                        </QsubWYSIWYG>}
                                        isImage={false}
                                        isQsub={true} />
                                    {/* <Heading.H4 dangerouslySetInnerHTML={createMarkup('The effectiveness of KEYTRUDA QLEX for its approved indications has been established based upon the evidence from the adequate and well-controlled studies conducted with KEYTRUDA and additional data that demonstrated comparable pharmacokinetic, efficacy, and safety profiles between KEYTRUDA QLEX and KEYTRUDA in study MK-3475A-D77')} /> */}
                                </PageSubSection>

                            </PageSection>
                        </ResultSectionWrapper>
                        <PageSection bgColor="cloud" title="Safety Profile">
                            <PageSubSection title="MK-3475A-D77 Safety Results in Patients With mNSCLC Who Received KEYTRUDA QLEX in Combination With Chemotherapy" isQsub={true}>
                                <QsubWYSIWYG>
                                    <p>Serious adverse reactions occurred in 39% of patients with mNSCLC who received KEYTRUDA QLEX in combination with chemotherapy. Serious adverse reactions in ≥1% of patients with mNSCLC who received KEYTRUDA QLEX were pneumonia (10%), thrombocytopenia (4%), febrile neutropenia (4%), neutropenia (2.8%), musculoskeletal pain (2%), pneumonitis (2%), diarrhea (1.6%), rash (1.2%), respiratory failure (1.2%), and anemia (1.2%).</p>
                                    <p>Fatal adverse reactions occurred in 10% of patients with mNSCLC who received KEYTRUDA QLEX in combination with chemotherapy, including pneumonia (3.2%), neutropenic sepsis (2%), death not otherwise specified (1.6%), respiratory failure (1.2%), parotitis (0.4%), pneumonitis (0.4%), pneumothorax (0.4%), pulmonary embolism (0.4%), neutropenic colitis (0.4%), and seizure (0.4%).</p>
                                    <p>Permanent discontinuation of KEYTRUDA QLEX in combination with chemotherapy due to an adverse reaction occurred in 16% of patients with mNSCLC. Adverse reactions which resulted in permanent discontinuation of KEYTRUDA QLEX in ≥2% of patients with mNSCLC included pneumonia and pneumonitis.</p>
                                    <p>Dosage interruptions of KEYTRUDA QLEX in combination with chemotherapy due to an adverse reaction occurred in 45% of patients with mNSCLC. Adverse reactions which required dosage interruption in ≥2% of patients with mNSCLC included neutropenia, anemia, thrombocytopenia, pneumonia, rash, and increased aspartate aminotransferase.</p>
                                    <p>The most common adverse reactions (≥20%) in patients who received KEYTRUDA QLEX in combination with chemotherapy were nausea (25%), fatigue (25%), and musculoskeletal pain (21%).</p>
                                </QsubWYSIWYG>
                            </PageSubSection>

                            {/* Table 3 */}
                            <Spacer mobSpace={10} deskSpace={20} />
                            <Heading.H4 dangerouslySetInnerHTML={createMarkup("Adverse Reactions Occurring in ≥10% of Patients With mNSCLC Receiving KEYTRUDA QLEX in Combination With Chemotherapy in Study MK-3475A-D77")} />
                            <Spacer deskSpace={10} />
                            <PinchContainer>
                                <PinchIcon />
                                <PinchLabel>Pinch to zoom & enlarge</PinchLabel>
                            </PinchContainer>

                            <ResponsiveTable
                                cssData={`
                                        border-radius: 8px 8px 0 0;
                                        border-bottom:1px solid ${colors.darkPurple};
                                        box-shadow: -4px 0 6px -2px rgba(0,0,0,0.1), 4px 0 6px -2px rgba(0,0,0,0.1);
                                        `}
                            >

                                <ResponsiveHeadData headerType="charcoal-fill" headerData={[
                                    {
                                        ThData: "",
                                        width: 3
                                    },
                                    {
                                        colSpan: 2,
                                        width: 3,
                                        ThData: <p className="text-center">KEYTRUDA QLEX and Platinum Doublet Chemotherapy (n=251)</p>
                                    },
                                    {
                                        colSpan: 2,
                                        width: 3,
                                        ThData: <p className="text-center">KEYTRUDA and Platinum Doublet Chemotherapy (n=126)</p>
                                    },
                                ]} />
                                <ResponsiveRowData rowData={[
                                    {
                                        rowType: "purple-bg",
                                        rowTdData: [{ content: <p className="text-center">Adverse Reactions</p> }, { content: <p className="text-center">All Grades<sup>j</sup><br />(%)</p> }, { content: <p className="text-center">Grades 3&#8288;–&#8288;4<br />(%)</p> }, { content: <p className="text-center">All Grades<sup>j</sup><br />(%)</p> }, { content: <p className="text-center">Grades 3&#8288;–&#8288;4<br />(%)</p> }]
                                    },
                                    {
                                        rowType: "grey-bg-purple-border",
                                        rowTdData: [{ colSpan: 5, content: "Gastrointestinal" }]
                                    },
                                    {
                                        rowType: "bg-cloud",
                                        rowTdData: [{ content: "Nausea" }, { content: <p className="text-center fw-400 text-charcoal">25</p> }, { content: <p className="text-center fw-400 text-charcoal">1.2</p> }, { content: <p className="text-center fw-400 text-charcoal">25</p> }, { content: <p className="text-center fw-400 text-charcoal">0.8</p> }]
                                    },
                                    {
                                        rowType: "bg-mist",
                                        rowTdData: [{ content: <p>Diarrhea<sup>k</sup></p> }, { content: <p className="text-center fw-400 text-charcoal">16</p> }, { content: <p className="text-center fw-400 text-charcoal">2</p> }, { content: <p className="text-center fw-400 text-charcoal">14</p> }, { content: <p className="text-center fw-400 text-charcoal">0.8</p> }]
                                    },
                                    {
                                        rowType: "bg-cloud",
                                        rowTdData: [{ content: "Constipation" }, { content: <p className="text-center fw-400 text-charcoal">14</p> }, { content: <p className="text-center fw-400 text-charcoal">0</p> }, { content: <p className="text-center fw-400 text-charcoal">18</p> }, { content: <p className="text-center fw-400 text-charcoal">1.6</p> }]
                                    },
                                    {
                                        rowType: "grey-bg-purple-border",
                                        rowTdData: [{ colSpan: 5, content: "GENERAL" }]
                                    },
                                    {
                                        rowType: "bg-cloud",
                                        rowTdData: [{ content: <p>Fatigue<sup>l</sup></p> }, { content: <p className="text-center fw-400 text-charcoal">25</p> }, { content: <p className="text-center fw-400 text-charcoal">3.6</p> }, { content: <p className="text-center fw-400 text-charcoal">26</p> }, { content: <p className="text-center fw-400 text-charcoal">3.2</p> }]
                                    },
                                    {
                                        rowType: "grey-bg-purple-border",
                                        rowTdData: [{ colSpan: 5, content: "Musculoskeletal and Connective Tissue" }]
                                    },
                                    {
                                        rowType: "bg-cloud",
                                        rowTdData: [{ content: <p>Musculoskeletal pain<sup>m</sup></p> }, { content: <p className="text-center fw-400 text-charcoal">21</p> }, { content: <p className="text-center fw-400 text-charcoal">2.4</p> }, { content: <p className="text-center fw-400 text-charcoal">30</p> }, { content: <p className="text-center fw-400 text-charcoal">2.4</p> }]
                                    },
                                    {
                                        rowType: "grey-bg-purple-border",
                                        rowTdData: [{ colSpan: 5, content: "Skin and Subcutaneous Tissue" }]
                                    },
                                    {
                                        rowType: "bg-cloud",
                                        rowTdData: [{ content: <p>Rash<sup>n</sup></p> }, { content: <p className="text-center fw-400 text-charcoal">18</p> }, { content: <p className="text-center fw-400 text-charcoal">2</p> }, { content: <p className="text-center fw-400 text-charcoal">19</p> }, { content: <p className="text-center fw-400 text-charcoal">0.8</p> }]
                                    },
                                    {
                                        rowType: "bg-mist",
                                        rowTdData: [{ content: "Pruritus" }, { content: <p className="text-center fw-400 text-charcoal">12</p> }, { content: <p className="text-center fw-400 text-charcoal">0</p> }, { content: <p className="text-center fw-400 text-charcoal">13</p> }, { content: <p className="text-center fw-400 text-charcoal">0.8</p> }]
                                    },
                                    {
                                        rowType: "grey-bg-purple-border",
                                        rowTdData: [{ colSpan: 5, content: "Endocrine" }]
                                    },
                                    {
                                        rowType: "bg-cloud",
                                        rowTdData: [{ content: "Hypothyroidism" }, { content: <p className="text-center fw-400 text-charcoal">14</p> }, { content: <p className="text-center fw-400 text-charcoal">0</p> }, { content: <p className="text-center fw-400 text-charcoal">12</p> }, { content: <p className="text-center fw-400 text-charcoal">0</p> }]
                                    },
                                    {
                                        rowType: "grey-bg-purple-border",
                                        rowTdData: [{ colSpan: 5, content: "Infections" }]
                                    },
                                    {
                                        rowType: "bg-cloud",
                                        rowTdData: [{ content: <p>Pneumonia<sup>o</sup></p> }, { content: <p className="text-center fw-400 text-charcoal">17</p> }, { content: <p className="text-center fw-400 text-charcoal">10</p> }, { content: <p className="text-center fw-400 text-charcoal">16</p> }, { content: <p className="text-center fw-400 text-charcoal">7</p> }]
                                    },
                                    {
                                        rowType: "grey-bg-purple-border",
                                        rowTdData: [{ colSpan: 5, content: "Nervous System" }]
                                    },
                                    {
                                        rowType: "bg-cloud",
                                        rowTdData: [{ content: <p>Peripheral neuropathy<sup>p</sup></p> }, { content: <p className="text-center fw-400 text-charcoal">11</p> }, { content: <p className="text-center fw-400 text-charcoal">0.4</p> }, { content: <p className="text-center fw-400 text-charcoal">14</p> }, { content: <p className="text-center fw-400 text-charcoal">0</p> }]
                                    },
                                    {
                                        rowType: "grey-bg-purple-border",
                                        rowTdData: [{ colSpan: 5, content: "Metabolism and Nutrition" }]
                                    },
                                    {
                                        rowType: "bg-cloud",
                                        rowTdData: [{ content: "Decreased appetite" }, { content: <p className="text-center fw-400 text-charcoal">11</p> }, { content: <p className="text-center fw-400 text-charcoal">0.8</p> }, { content: <p className="text-center fw-400 text-charcoal">21</p> }, { content: <p className="text-center fw-400 text-charcoal">2.4</p> }]
                                    },
                                    {
                                        rowType: "bg-mist",
                                        rowTdData: [{ content: "Hyperglycemia" }, { content: <p className="text-center fw-400 text-charcoal">11</p> }, { content: <p className="text-center fw-400 text-charcoal">0.8</p> }, { content: <p className="text-center fw-400 text-charcoal">11</p> }, { content: <p className="text-center fw-400 text-charcoal">0.8</p> }]
                                    },
                                    {
                                        rowType: "grey-bg-purple-border",
                                        rowTdData: [{ colSpan: 5, content: "Respiratory, Thoracic, and Mediastinal" }]
                                    },
                                    {
                                        rowType: "bg-cloud",
                                        rowTdData: [{ content: <p>Cough<sup>q</sup></p> }, { content: <p className="text-center fw-400 text-charcoal">10</p> }, { content: <p className="text-center fw-400 text-charcoal">0</p> }, { content: <p className="text-center fw-400 text-charcoal">11</p> }, { content: <p className="text-center fw-400 text-charcoal">0.8</p> }]
                                    },
                                ]} />
                            </ResponsiveTable>
                            <Spacer mobSpace={10} />
                            <QsubWYSIWYG>
                                <ul>
                                    <li>Clinically relevant adverse reactions in &lt;10% of patients who received KEYTRUDA QLEX included local injection-site reactions (2.4%)</li>
                                </ul>
                            </QsubWYSIWYG>
                            <Spacer mobSpace={15} deskSpace={15} />

                            <QsubWYSIWYG>
                                <Heading.H4>The safety of KEYTRUDA QLEX for its approved indications is based on study MK-3475A-D77 and the safety of KEYTRUDA® (pembrolizumab) given as a single agent or in combination</Heading.H4>
                                {/* <p><strong>The safety of KEYTRUDA QLEX for the approved indications is also based on the safety of intravenous pembrolizumab given as a single agent or in combination with other antitumor medicines.</strong></p> */}
                                <p>The most common adverse reactions (≥20%) in patients who received KEYTRUDA QLEX in combination with chemotherapy were nausea (25%), fatigue (25%), and musculoskeletal pain (21%).</p>
                                <p>The most common adverse reactions (≥20%) in patients who received intravenous pembrolizumab were:</p>
                                <ul>
                                    <li>as a single agent: fatigue, musculoskeletal pain, rash, diarrhea, pyrexia, cough, decreased appetite, pruritus, dyspnea, constipation, pain, abdominal pain, nausea, and hypothyroidism</li>
                                    <li>in combination with chemotherapy or chemoradiotherapy: fatigue/asthenia, nausea, constipation, diarrhea, decreased appetite, rash, vomiting, cough, dyspnea, pyrexia, alopecia, peripheral neuropathy, mucosal inflammation, stomatitis, headache, weight loss, abdominal pain, arthralgia, myalgia, insomnia, palmar-plantar erythrodysesthesia, urinary tract infection, hypothyroidism, radiation skin injury, dysphagia, dry mouth, and musculoskeletal pain</li>
                                    <li>in combination with chemotherapy and bevacizumab: peripheral neuropathy, alopecia, anemia, fatigue/asthenia, nausea, neutropenia, diarrhea, hypertension, thrombocytopenia, constipation, arthralgia, vomiting, urinary tract infection, rash, leukopenia, hypothyroidism, decreased appetite, pyrexia, epistaxis, decreased white blood cell count, and stomatitis.</li>
                                    <li>in combination with enfortumab vedotin: rash, peripheral neuropathy, fatigue, pruritus, diarrhea, alopecia, weight loss, decreased appetite, dry eye, nausea, constipation, dysgeusia, and urinary tract infection</li>
                                </ul>
                            </QsubWYSIWYG>

                            <Spacer mobSpace={15} deskSpace={15} />
                            <Footnote label="j." text="Graded per NCI CTCAE v5.0." />
                            <Footnote label="k." text="Includes diarrhea, colitis, and enterocolitis." />
                            <Footnote label="l." text="Includes fatigue, asthenia." />
                            <Footnote label="m." text="Includes musculoskeletal pain, arthralgia, arthritis, back pain, bone pain, musculoskeletal chest pain, musculoskeletal stiffness, myalgia, non-cardiac chest pain, and pain in extremity." />
                            <Footnote label="n." text="Includes rash, dermatitis, dermatitis acneiform, dermatitis bullous, dermatitis exfoliative, eczema, erythema multiforme, immune-mediated dermatitis, rash erythematous, rash follicular, rash generalized, rash macular, rash maculo-papular, rash papular, rash pruritic, and skin exfoliation." />
                            <Footnote label="o." text="Includes pneumonia, COVID-19 pneumonia, lower respiratory tract infection, lung abscess, pneumocystis jirovecii pneumonia, pneumonia bacterial, and pneumonia mycoplasmal." />
                            <Footnote label="p." text="Includes neuropathy peripheral, hypoaesthesia, neuralgia, paraesthesia, and peripheral sensory neuropathy." />
                            <Footnote label="q." text="Includes cough, productive cough, and upper-airway cough syndrome." />
                            <DefinitionBlock text="NCI CTCAE = National Cancer Institute Common Terminology Criteria for Adverse Events." />
                        </PageSection>
                        <PageSection bgColor="white" title="Dosing & Preparation">
                            <Spacer deskSpace={20} mobSpace={15} />
                            <PageSubSection id='offer-your-patients' title="KEYTRUDA QLEX: Dosing Options" isQsub={true}>
                                <Heading.H4 dangerouslySetInnerHTML={createMarkup("Two Dosing Options")} />
                                <Spacer deskSpace={-5} />
                                <CustomRemoveSpacer>
                                    <BreakoutContentRow>
                                        <BreakoutContentCard icon={() => <img src="/static/images/qsub-1-minute-icon.svg" alt="1 Minute" width={60} height={60} />} title="Every 3 Weeks (Q3W)<sup>r</sup>">
                                            <QsubWYSIWYG>
                                                <ul>
                                                    <li>395 mg pembrolizumab and 4,800 units berahyaluronidase alfa</li>
                                                    <li><b>1-minute administration<sup>s</sup></b></li>
                                                    <li>2.4-mL injection volume</li>
                                                </ul>
                                            </QsubWYSIWYG>
                                        </BreakoutContentCard>
                                        <BreakoutContentCard icon={() => <img src="/static/images/qsub-2-minute-icon.svg" alt="2 Minutes" width={60} height={60} />} title="Every 6 Weeks (Q6W)<sup>r</sup>">
                                            <QsubWYSIWYG>
                                                <ul>
                                                    <li>790 mg pembrolizumab and 9,600 units berahyaluronidase alfa</li>
                                                    <li><b>2-minute administration<sup>s</sup></b></li>
                                                    <li>4.8-mL injection volume</li>
                                                </ul>
                                            </QsubWYSIWYG>
                                        </BreakoutContentCard>
                                    </BreakoutContentRow>
                                    <Spacer deskSpace={10} />
                                    <Footnote label="r." text='Refer to the Prescribing Information for duration of treatment for each indication.' />
                                    <Footnote label="s." text="Does not account for all aspects of treatment. Actual clinic time may vary." />

                                </CustomRemoveSpacer>
                                <SecondaryCallout imgSrc={dualArrow} alt="" title="Patients have the option to switch from KEYTRUDA to KEYTRUDA QLEX—or KEYTRUDA QLEX to KEYTRUDA—at their next scheduled dose" isQsub={true} />
                                {/* <QsubWYSIWYG>
                                    <p>Treatment with KEYTRUDA QLEX for adjuvant RCC should continue until disease progression, unacceptable toxicity, or up to 12 months</p>
                                </QsubWYSIWYG> */}
                                <ScrollCont id='qlex-dosing-site'></ScrollCont>
                                <Spacer deskSpace={20} mobSpace={15} />
                                <AbdomenHeading dangerouslySetInnerHTML={createMarkup('Two Subcutaneous Injection-Site Options: <strong>Abdomen or Thigh</strong>')} />
                                <Spacer deskSpace={10} />
                                <ImageWrapper />
                                <Spacer deskSpace={20} mobSpace={15} />
                                <Heading.H4 dangerouslySetInnerHTML={createMarkup('Administration Information')} />
                                <QsubWYSIWYG>
                                    <ul>
                                        <li>KEYTRUDA QLEX has different recommended dosage and administration instructions than KEYTRUDA</li>
                                        <li>Administer KEYTRUDA QLEX as a subcutaneous injection into the thigh or abdomen, avoiding the <span style={{whiteSpace: 'nowrap'}}>5-cm</span> area around the navel</li>
                                        <li>Inject into healthy skin and never into areas where the skin is red, bruised, tender, or hard. Ensure the injection site is at least 2.5 cm from the previous injection site</li>
                                        <li>For every-3-week dosing (395 mg/4,800 units): inject 2.4 mL subcutaneously in 1 minute</li>
                                        <li>For every-6-week dosing (790 mg/9,600 units): inject 4.8 mL subcutaneously in 2 minutes</li>
                                        <li>During treatment with KEYTRUDA QLEX, do not administer other medications for subcutaneous use at the same site as KEYTRUDA QLEX</li>
                                        <li>KEYTRUDA QLEX must be administered by a healthcare provider</li>
                                        <li>Do not administer KEYTRUDA QLEX intravenously</li>
                                        {/* <li>Inject into healthy skin and never into areas where the skin is red, bruised, tender or hard</li> */}
                                        {/* <li>Do not administer other medications for subcutaneous use at the same site as KEYTRUDA QLEX</li> */}
                                    </ul>
                                </QsubWYSIWYG>
                                <Spacer deskSpace={15} mobSpace={10} />
                                <FeaturedCTA 
                                    title="View Indication-Specific Dosing Information"
                                    ctas={[{label: "View Dosing", url: "#indication-specific-dosing-information"}]}
                                    iconAlt=""
                                    brandType="qsub"
                                />
                            </PageSubSection>
                            <PageSubSection title="Preparation of the Syringe" isQsub={true}>
                                <PSAImageStepsList data={PrepStepsList} stepCount={PrepStepsList.length} theme='cloud' brandType="qsub"></PSAImageStepsList>
                            </PageSubSection>
                            <PageSubSection title="Storing the Prepared Syringe" isQsub={true}>
                                <QsubWYSIWYGWrapper>
                                    <p><strong>KEYTRUDA QLEX does not contain a preservative</strong> and should be used immediately after withdrawing from the vial. If not used immediately, store the syringe containing KEYTRUDA QLEX with the transfer needle and cap in place:</p>
                                    <ul>
                                        <li>At room temperature 20°C to 25°C (68°F to 77°F) for up to <strong>8 hours</strong>, or</li>
                                        <li>In the refrigerator at 2°C to 8°C (36°F to 46°F), protected from light for up to 96 hours. The 96-hour period may include up to 8 hours at room temperature.</li>
                                        <li>Discard if storage time exceeds these limits</li>
                                        <li>If refrigerated, allow the filled syringe to come to room temperature for at least 30 minutes prior to administration</li>
                                        <li>Do not freeze</li>
                                    </ul>
                                </QsubWYSIWYGWrapper>
                                <SecondaryCallout
                                    isQsub={true}
                                    isImage={true}
                                    imgSrc={injectionIcon}
                                    alt=""
                                    title='The Prepared Syringe Can Be Stored at Room Temperature 20°C to 25°C (68°F to 77°F) for Up to 8 Hours' />
                            </PageSubSection>
                            <PageSubSection title="Storing the Vials" isQsub={true}>
                                <QsubWYSIWYG>
                                    <p>KEYTRUDA QLEX is a sterile, preservative-free, clear to slightly opalescent, colorless to slightly yellow solution supplied in single-dose vials for subcutaneous administration. Each carton contains 1 single-dose vial.</p>
                                    <ul>
                                        <li>Store vials in the refrigerator at 2°C to 8°C (36°F to 46°F) in the original carton to protect from light</li>
                                        <li>Do not shake or freeze vials</li>
                                    </ul>
                                </QsubWYSIWYG>
                                <Spacer deskSpace={20} mobSpace={15} />
                                <PSAImageStepsList data={StoreList} stepCount={PrepStepsList.length} theme='cloud' brandType="qsub"></PSAImageStepsList>
                                <Spacer deskSpace={10} mobSpace={15} />
                                <PSAfootnote>NDC = national drug code.</PSAfootnote>
                            </PageSubSection>
                            
                            <PageSubSection title="Indication-Specific Dosing Information" isQsub={true}>
                                <TriageListWrapper>
                                <TriageList listType="dosingQsub" brandType='qlex' />
                                </TriageListWrapper>
                            </PageSubSection>
                            
                        </PageSection>

                    </TemplateColumn>
                    <TemplateColumn id="template-e-sidebar">
                        <PageSection bgColor="mist">
                            <CrossLink {...crossLinkContent} />
                        </PageSection>
                    </TemplateColumn>
                </TemplateColumnWithSidebarContainer>
                <TemplateColumn id="template-e-secondary">
                    <PageSection bgColor="qsublight">
                        <RelatedContent items={relatedContent} />
                    </PageSection>
                    {/* <PageSection bgColor="mist">
                        <ReferencesBlock references={pageReferences} />
                    </PageSection> */}
                </TemplateColumn>
            </div>
        </QsubLayout>
        </FilterProvider>
    )
}

export default Page;